import * as ScholarshipTypeStoreActions from './scholarshiptype.actions';
import * as ScholarshipTypeStoreSelectors from './scholarshiptype.selectors';
import * as ScholarshipTypeStoreReducer from './scholarshiptype.reducer';

export {
  ScholarshipTypeStoreActions,
  ScholarshipTypeStoreSelectors,
  ScholarshipTypeStoreReducer
};
